// pdfEstilos.js

export const FUENTES = {
  TITULO: { font: "Century Gothic", style: "bold", size: 18 },
  SUBTITULO: { font: "Century Gothic", style: "bold", size: 14 },
  TEXTO_BOLD: { font: "Century Gothic", style: "bold", size: 12 },
  TEXTO: { font: "Century Gothic", style: "normal", size: 12 },
  PIE: { font: "Century Gothic", style: "italic", size: 8 },
};

export const POSICIONES = {
  ENCABEZADO_Y: 33,
  PIE_Y: 280,
  MARGEN_X: 20,
  DATOS_Y: 40,
  MARGEN_DATOS_X: 40,
  ANCHO_TEXTO: 170,
};

export const COLORES = {
  LINEA: [0],
  TEXTO: [0],
};

export const LINEAS = {
  GROSOR: 0.5,
  GROSOR_PRES: 0.1,
  POSICION_ENCABEZADO: [20, 26, 190, 26],
  POSICION_DATO: [20, 54, 190, 54],
};
